import { IInitialState } from "us.collection.admin/reducers/CreditorGroup/Interfaces";

export const initialState: IInitialState = {
  creditorGroups: {
    data: [],
    isFetching: false,
  },
  creditorGroupDetails: {
    data: {
      id: -1,
      groupName: "",
      activeStatus: true,
      description: "",
      numberOfCreditors: -1,
    },
    isFetching: false,
  },
  drawer: {
    title: "",
    visible: false,
    isNewCreditorGroup: true,
  },
  selectedCreditors: {
    data: [],
    isFetching: false,
  },
};
